import { TranslateHelper } from '@app/_helpers';
import { Component, Input, OnInit } from '@angular/core';
/* import { CompaniesService } from '@app/_services'; */
import * as _ from "lodash";
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-block-gallery',
    templateUrl: './block-gallery.component.html',
    styleUrls: ['./block-gallery.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf]
})


export class BlockGalleryComponent implements OnInit {
    @Input() item: any = [];
    images;

    constructor(public translateHelper: TranslateHelper) {
    }

    ngOnInit(): void {
        let images = [];
        _.forEach(this.item?.imagesList, image => {
            images.push({ path: image.url });
        });

        this.images = {
            images,
            index: 0
        };
    }

    showGallery(id) {


        /*
        if (!this.images) {
            this.companiesService.getgallery(id).subscribe(imagesList => {
                let images = [];
                _.forEach(images, image => {
                    images.push({ path: image.url });
                });

                this.images = {
                    images,
                    index: 0
                };
                this.gallery.load(this.images);
            });
        } else {
            this.gallery.load(this.images);
        }
     */
    }
}
